<div class="container">
    <div class="row">
        <div class="col-12 mb-5">
            <app-toolkit-page-title title="Attesa profilo"></app-toolkit-page-title>
            <div class="card">
                <div class="card-body">
                    <p>Al momento il profilo non risulta abilitato. Se il problema persiste, si prega di contattare l'assistenza.</p>
                </div>
            </div>
        </div>
    </div>
</div>